import { render, staticRenderFns } from "./ClientePolizaInfo.vue?vue&type=template&id=72ea255e&scoped=true&"
import script from "./ClientePolizaInfo.vue?vue&type=script&lang=js&"
export * from "./ClientePolizaInfo.vue?vue&type=script&lang=js&"
import style0 from "./ClientePolizaInfo.vue?vue&type=style&index=0&id=72ea255e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ea255e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
installComponents(component, {VExpansionPanelContent})
